var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomRightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 514,
    viewBox: "0 0 481 514",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 129.75,
    width: 366.5,
    height: 383.5,
    rx: 74.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.946 83.7138C206.786 129.948 199.273 194.372 155.166 227.609C155.166 227.609 126.923 190.129 92.0829 143.895C57.2432 97.6615 29 60.1815 29 60.1815C73.1074 26.9442 137.107 37.48 171.946 83.7138Z",
    fill: "#F9AB00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 113.5,
    y: 44.5,
    width: 367,
    height: 384,
    rx: 74.5,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRightBg);
export default __webpack_public_path__ + "static/media/bottom-right-bg.f88d97c538bee82bf2daa8218f693a46.svg";
export { ForwardRef as ReactComponent };